import { CurrentHurricane, CurrentTrackPoint, HurricaneCategoryNumber, HurricaneOutlookSummaryType, IStdParameters } from '../common/interfaces/types';
import { baseHurricaneWidgetSpotlightIconExtension, baseHurricaneWidgetSpotlightIconPath, baseSelectedHurricaneDetailIconPath, baseSelectedPastHurricaneDetailIconSubPath, HurricaneTropicalDepressionType, HurricaneTropicalStormType } from './constants';
import { 
    AtlanticHurricaneBasinID,
    CentralPacificHurricaneBasinID,
    EasternPacificHurricaneBasinID } from '@weatherbug/common/dist/data-layer/actions/Hurricane/Outlook/Bulletin/hurricaneOutlookBulletinAction';
export interface CommonHurricaneWidgetUIProps {
    isLoading: boolean;
    dataLoadError: boolean;
    // TODO: Get valid type for activeHurricaneData and hurricaneOutlookData
    activeHurricaneData: CurrentTrackPoint;
    hurricaneOutlookSummaryData: HurricaneOutlookSummaryType;
}

export const HurricaneWidgetType = {
    hurricaneOutlook: 'hurricaneOutlook',
    activeHurricane: 'activeHurricane',
    noActiveHurricaneOrWarning: 'noActiveHurricaneOrWarning'
} as const;

export type IconSubPath = HurricaneCategoryNumber | typeof HurricaneTropicalStormType | typeof HurricaneTropicalDepressionType;

/**
 * Generates a union type for all the valid sub paths that hurricane spotlight icons are allowed to have.
 * | "/images/hurricane/widget/spotlight_ic_1.png" 
 * | "/images/hurricane/widget/spotlight_ic_2.png" 
 * | "/images/hurricane/widget/spotlight_ic_3.png" 
 * | "/images/hurricane/widget/spotlight_ic_4.png" 
 * | "/images/hurricane/widget/spotlight_ic_5.png" 
 * | "/images/hurricane/widget/spotlight_ic_TS.png" 
 * | "/images/hurricane/widget/spotlight_ic_TD.png
 */
export type HurricaneWidgetSpotlightIconType = `${typeof baseHurricaneWidgetSpotlightIconPath}${IconSubPath}${typeof baseHurricaneWidgetSpotlightIconExtension}`;

/**
 * Generates a union type for all the valid sub paths that current hurricane Detail icons are allowed to have.
 * | "/images/hurricane/details/ic_detail_TS.png" 
 * | "/images/hurricane/details/ic_detail_TD.png" 
 * | "/images/hurricane/details/ic_detail_2.png" 
 * | "/images/hurricane/details/ic_detail_1.png" 
 * | "/images/hurricane/details/ic_detail_3.png" 
 * | "/images/hurricane/details/ic_detail_4.png" 
 * | "/images/hurricane/details/ic_detail_5.png" 
 * | "/images/hurricane/details/ic_detail_2.png" 
 * | "/images/hurricane/details/ic_detail_past_1.png" 
 * | "/images/hurricane/details/ic_detail_past_3.png" 
 * | "/images/hurricane/details/ic_detail_past_4.png" 
 * | "/images/hurricane/details/ic_detail_past_5.png"
 * | "/images/hurricane/details/ic_detail_past_TS.png" 
 * | "/images/hurricane/details/ic_detail_past_TD.png"
 */
export type CurrentHurricaneDetailIconType = 
    | `${typeof baseSelectedHurricaneDetailIconPath}${IconSubPath}${typeof baseHurricaneWidgetSpotlightIconExtension}`
    | `${typeof baseSelectedHurricaneDetailIconPath}${typeof baseSelectedPastHurricaneDetailIconSubPath}${IconSubPath}${typeof baseHurricaneWidgetSpotlightIconExtension}`;

export interface GetHurricaneOutlookSummaryActionType {
    includeForecast7d: boolean;
    latitude: number;
    longitude: number;
    forceRefreshOfCachedData: boolean;
    baseUrl: string;
    authId: string;
    secret: string;
    stdApiParameters: IStdParameters;
    verboseResponseKeys: boolean;
}

export type HurricaneOutlookBasinIDType = | AtlanticHurricaneBasinID | CentralPacificHurricaneBasinID | EasternPacificHurricaneBasinID;
